/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upload_Photos_Ai_Writes_Your_Story_Ships_WorldwideInputs */

const en_upload_photos_ai_writes_your_story_ships_worldwide = /** @type {(inputs: Upload_Photos_Ai_Writes_Your_Story_Ships_WorldwideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload photos, AI writes your story, ships worldwide`)
};

/** @type {(inputs: Upload_Photos_Ai_Writes_Your_Story_Ships_WorldwideInputs) => LocalizedString} */
const es_upload_photos_ai_writes_your_story_ships_worldwide = en_upload_photos_ai_writes_your_story_ships_worldwide;

/** @type {(inputs: Upload_Photos_Ai_Writes_Your_Story_Ships_WorldwideInputs) => LocalizedString} */
const fr_upload_photos_ai_writes_your_story_ships_worldwide = en_upload_photos_ai_writes_your_story_ships_worldwide;

/** @type {(inputs: Upload_Photos_Ai_Writes_Your_Story_Ships_WorldwideInputs) => LocalizedString} */
const de_upload_photos_ai_writes_your_story_ships_worldwide = en_upload_photos_ai_writes_your_story_ships_worldwide;

/** @type {(inputs: Upload_Photos_Ai_Writes_Your_Story_Ships_WorldwideInputs) => LocalizedString} */
const ja_upload_photos_ai_writes_your_story_ships_worldwide = en_upload_photos_ai_writes_your_story_ships_worldwide;

/** @type {(inputs: Upload_Photos_Ai_Writes_Your_Story_Ships_WorldwideInputs) => LocalizedString} */
const zh_upload_photos_ai_writes_your_story_ships_worldwide = en_upload_photos_ai_writes_your_story_ships_worldwide;

/** @type {(inputs: Upload_Photos_Ai_Writes_Your_Story_Ships_WorldwideInputs) => LocalizedString} */
const ar_upload_photos_ai_writes_your_story_ships_worldwide = en_upload_photos_ai_writes_your_story_ships_worldwide;

/** @type {(inputs: Upload_Photos_Ai_Writes_Your_Story_Ships_WorldwideInputs) => LocalizedString} */
const id_upload_photos_ai_writes_your_story_ships_worldwide = en_upload_photos_ai_writes_your_story_ships_worldwide;

/** @type {(inputs: Upload_Photos_Ai_Writes_Your_Story_Ships_WorldwideInputs) => LocalizedString} */
const it_upload_photos_ai_writes_your_story_ships_worldwide = en_upload_photos_ai_writes_your_story_ships_worldwide;

/** @type {(inputs: Upload_Photos_Ai_Writes_Your_Story_Ships_WorldwideInputs) => LocalizedString} */
const ru_upload_photos_ai_writes_your_story_ships_worldwide = en_upload_photos_ai_writes_your_story_ships_worldwide;

/** @type {(inputs: Upload_Photos_Ai_Writes_Your_Story_Ships_WorldwideInputs) => LocalizedString} */
const pt_upload_photos_ai_writes_your_story_ships_worldwide = en_upload_photos_ai_writes_your_story_ships_worldwide;

/** @type {(inputs: Upload_Photos_Ai_Writes_Your_Story_Ships_WorldwideInputs) => LocalizedString} */
const ko_upload_photos_ai_writes_your_story_ships_worldwide = en_upload_photos_ai_writes_your_story_ships_worldwide;

/**
* | output |
* | --- |
* | "Upload photos, AI writes your story, ships worldwide" |
*
* @param {Upload_Photos_Ai_Writes_Your_Story_Ships_WorldwideInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const upload_photos_ai_writes_your_story_ships_worldwide = /** @type {((inputs?: Upload_Photos_Ai_Writes_Your_Story_Ships_WorldwideInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upload_Photos_Ai_Writes_Your_Story_Ships_WorldwideInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_upload_photos_ai_writes_your_story_ships_worldwide(inputs)
	if (locale === "es") return es_upload_photos_ai_writes_your_story_ships_worldwide(inputs)
	if (locale === "fr") return fr_upload_photos_ai_writes_your_story_ships_worldwide(inputs)
	if (locale === "de") return de_upload_photos_ai_writes_your_story_ships_worldwide(inputs)
	if (locale === "ja") return ja_upload_photos_ai_writes_your_story_ships_worldwide(inputs)
	if (locale === "zh") return zh_upload_photos_ai_writes_your_story_ships_worldwide(inputs)
	if (locale === "ar") return ar_upload_photos_ai_writes_your_story_ships_worldwide(inputs)
	if (locale === "id") return id_upload_photos_ai_writes_your_story_ships_worldwide(inputs)
	if (locale === "it") return it_upload_photos_ai_writes_your_story_ships_worldwide(inputs)
	if (locale === "ru") return ru_upload_photos_ai_writes_your_story_ships_worldwide(inputs)
	if (locale === "pt") return pt_upload_photos_ai_writes_your_story_ships_worldwide(inputs)
	return ko_upload_photos_ai_writes_your_story_ships_worldwide(inputs)
});